import {
  breakpoints,
  colors,
  controlSizes,
  fonts,
  fontSizes,
  spacing,
} from "@softmax/design-system/tokens.stylex";
import * as stylex from "@stylexjs/stylex";

export const coworldLayout = stylex.create({
  stack: { display: "grid", gap: spacing.space16, minWidth: 0 },
  row: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    justifyContent: "space-between",
    gap: spacing.space12,
  },
  inline: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    gap: spacing.space8,
  },
  rowLink: {
    display: "flex",
    gap: spacing.space8,
    alignItems: "center",
    minHeight: {
      default: controlSizes.compact,
      [breakpoints.coarse]: controlSizes.touch,
    },
    color: colors.foreground,
    textDecoration: { default: "none", ":hover": "underline" },
    fontWeight: 500,
    overflowWrap: "anywhere",
    outlineColor: colors.foreground,
  },
  cell: {
    display: "flex",
    alignItems: "center",
    minHeight: {
      default: controlSizes.compact,
      [breakpoints.coarse]: controlSizes.touch,
    },
    fontSize: fontSizes.small,
    gap: spacing.space8,
  },
  secondaryColumn: {
    display: { default: "flex", [breakpoints.compact]: "none" },
  },
  mobile: {
    display: { default: "none", [breakpoints.compact]: "block" },
    fontSize: fontSizes.caption,
    color: colors.secondary,
    marginBottom: spacing.space8,
  },
  muted: { color: colors.secondary, fontSize: fontSizes.small, margin: 0 },
  mono: {
    fontFamily: fonts.mono,
    fontSize: fontSizes.caption,
    overflowWrap: "anywhere",
  },
  empty: {
    paddingBlock: spacing.space48,
    display: "grid",
    gap: spacing.space12,
    justifyItems: "start",
  },
  heading: { margin: 0, fontSize: fontSizes.label, fontWeight: 600 },
});
